<script>
  import { link } from "svelte-spa-router";
  export let value = "";
  export let valueOf = "";
  export let url = "";
  export let faClass = "";
  export let urgent = false;
</script>

<div
  class="px-4 py-4 rounded-md shadow-lg bg-white text-gray-500 border-l"
  class:border-gray-500={!urgent}
  class:border-red-400={urgent}
>
  <div class="text-base flex items-center uppercase">
    <i
      class={`fas ${faClass} mr-3`}
      class:text-gray-500={!urgent}
      class:text-red-400={urgent}
    />
    {valueOf}
  </div>
  <div class="text-4xl flex items-center justify-center">
    {value}
  </div>
  <!-- <div class="grid grid-cols-1">
    <a
      class={`mt-4 flex btn`}
      class:text-red-500.btn.btn-primary={urgent}
      class:text-red-400.btn.btn-red={!urgent}
      class:btn-red={urgent}
      class:btn-primary-outline={!urgent}
      href={url}
      use:link
    >
      <i class="fas fa-arrow-right mr-2" />
      View All
    </a>
  </div> -->
</div>
